/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSourceBulkMergePreview200ResponseData } from './GetSourceBulkMergePreview200ResponseData';
import {
    GetSourceBulkMergePreview200ResponseDataFromJSON,
    GetSourceBulkMergePreview200ResponseDataFromJSONTyped,
    GetSourceBulkMergePreview200ResponseDataToJSON,
    GetSourceBulkMergePreview200ResponseDataToJSONTyped,
} from './GetSourceBulkMergePreview200ResponseData';

/**
 * 
 * @export
 * @interface GetSourceBulkMergePreview200Response
 */
export interface GetSourceBulkMergePreview200Response {
    /**
     * 
     */
    data: GetSourceBulkMergePreview200ResponseData;
}

/**
 * Check if a given object implements the GetSourceBulkMergePreview200Response interface.
 */
export function instanceOfGetSourceBulkMergePreview200Response(value: object): value is GetSourceBulkMergePreview200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function GetSourceBulkMergePreview200ResponseFromJSON(json: any): GetSourceBulkMergePreview200Response {
    return GetSourceBulkMergePreview200ResponseFromJSONTyped(json, false);
}

export function GetSourceBulkMergePreview200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSourceBulkMergePreview200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': GetSourceBulkMergePreview200ResponseDataFromJSON(json['data']),
    };
}

export function GetSourceBulkMergePreview200ResponseToJSON(json: any): GetSourceBulkMergePreview200Response {
    return GetSourceBulkMergePreview200ResponseToJSONTyped(json, false);
}

export function GetSourceBulkMergePreview200ResponseToJSONTyped(value?: GetSourceBulkMergePreview200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': GetSourceBulkMergePreview200ResponseDataToJSON(value['data']),
    };
}

